export default __webpack_public_path__ + "static/media/colors.90a19ef3.svg";